import { render, staticRenderFns } from "./pageTitle.vue?vue&type=template&id=3a493546&scoped=true"
import script from "./pageTitle.vue?vue&type=script&lang=js"
export * from "./pageTitle.vue?vue&type=script&lang=js"
import style0 from "./pageTitle.vue?vue&type=style&index=0&id=3a493546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a493546",
  null
  
)

export default component.exports